import { promocionPara } from '@tanteo/compartido';
import type { DescuentoDeLinea, LineaMostrador } from '@tanteo/compartido';
import type { DescuentoDelNegocio } from '../../lib/api-descuentos';

/** La rebaja que una promoción automática pone en una línea. */
function descuentoDePromocion(d: DescuentoDelNegocio): DescuentoDeLinea {
  return {
    descuentoId: d.id,
    nombre: d.nombre,
    libre: false,
    automatico: true,
    tipo: d.forma === 'lleva_paga' ? 'lleva_paga' : d.forma === 'porcentaje' ? 'pct' : 'monto_unidad',
    valor: d.valor ?? 0,
    lleva: d.lleva,
    paga: d.paga,
    maxVeces: d.maxVeces,
    maxUnidades: d.maxUnidades,
  };
}

/**
 * Pone en cada línea la promoción vigente que la cubre y quita la que ya no vale. Respeta el descuento manual
 * y las promociones que el cajero quitó; con descuento a la venta no pone ninguna. Sin cambios, devuelve las mismas.
 */
export function aplicarPromociones(
  lineas: LineaMostrador[],
  promociones: DescuentoDelNegocio[],
  categoriaDe: (productoId: string) => string | undefined,
  fecha: string,
  conDescuentoVenta: boolean
): LineaMostrador[] {
  let cambio = false;
  const nuevas = lineas.map((l) => {
    if (l.descuento && !l.descuento.automatico) return l;
    const categoria = l.categoria ?? categoriaDe(l.productoId);
    const promo = conDescuentoVenta ? null : promocionPara(promociones, l.productoId, categoria, fecha, l.promocionQuitada);
    const actual = l.descuento ?? null;
    if ((promo?.id ?? null) === (actual?.descuentoId ?? null) && categoria === l.categoria) return l;
    cambio = true;
    return { ...l, categoria, descuento: promo ? descuentoDePromocion(promo) : null };
  });
  return cambio ? nuevas : lineas;
}
